import React from 'react'
import './requestquote.scss'
import { Row, Col, Button } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import { images } from '../../../utils/customFn';
const RequestQuote = () => {
    return (
        <div className='request-quote-wrapper'>
            <Row>
                <Col sm={12} md={8} lg={8} xl={8}>
                    <div className='talk-form-main'>
                        <div className='top-heading'>
                            <h3>Request a quote</h3>
                            <p>Experience the Sentry difference like others in your industry already have. Complete this simple form and a Sentry representative will contact you.</p>
                            
                        </div>
                        <Form>
                            <h4>Business info</h4>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Industry*</Form.Label>
                                <Form.Control type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Company name*</Form.Label>
                                <Form.Control type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Address*</Form.Label>
                                <Form.Control type="text" />
                            </Form.Group>
                            <Row>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>City*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={3} xl={3}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>State*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={3} xl={3}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Zip*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} md={6} lg={3} xl={3}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Year established*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Number of employees</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <h4>Contact info</h4>
                            <Row>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Phone*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Email*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Tell us more about your insurance needs</Form.Label>
                                <Form.Control as="textarea" rows={3} type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Current policy expiration date</Form.Label>
                                <Form.Control type="date" />
                            </Form.Group>
                            <div className='term-condition'>
                                <p>By pressing submit form, you agree that the information you are providing is your own and we may use the information you provide according to our <a href="https://www.sentry.com/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a> and <a href="https://www.sentry.com/terms-and-conditions" rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a>.</p>
                            </div>
                            <div className='bottom-btn'>
                                <Button className='submit-btn' type="submit">
                                    Submit form
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col sm={12} md={4} lg={4} xl={4}>
                    <div className='media-img'>
                        <img src={images['Clipboards.svg']} alt="media" />
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default RequestQuote